import { FormControl, MenuItem } from '@mui/material';
import Select from '@mui/material/Select';

import React, { ReactNode, useState } from 'react';

import styles from './SelectComponent.module.scss';

type OptionType = {
	value: number | string;
	label: number | string;
};

interface ISelectProps {
	type: string;
	selectList: OptionType[];
	defaultValue: string | number;
	handleValueChange: (val: number | string) => void;
	renderValue?: (val: string | number) => ReactNode | undefined;
	className?: string;
	customFormControlClass?: string;
}

const SelectComponent = (props: ISelectProps) => {
	const {
		type,
		defaultValue,
		selectList,
		handleValueChange,
		renderValue,
		className,
		customFormControlClass,
	} = props;
	const [val, setVal] = useState<number | string>(defaultValue);

	const handleChange = (event: any) => {
		setVal(type === 'number' ? Number(event.target.value) : event.target.value);
		handleValueChange(
			type === 'number' ? Number(event.target.value) : event.target.value,
		);
	};

	const defaultClass = styles['form-style'];
	const customClass = customFormControlClass
		? `${defaultClass} ${customFormControlClass}`
		: defaultClass;

	return (
		<FormControl className={customClass} size="small">
			<Select
				className={className}
				labelId="unique-select-label"
				id="unique-select"
				value={val}
				displayEmpty
				onChange={(event) => handleChange(event)}
				renderValue={renderValue}
				inputProps={{
					'aria-label': 'Without label',
					'data-testid': 'selectcompid',
				}}
				MenuProps={{
					disableScrollLock: true,
				}}
			>
				{selectList.map(({ value, label }) => (
					<MenuItem value={value} key={value}>
						{label}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};

export default SelectComponent;
